import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlbumGroupeDropdownComponent } from './album-groupe-dropdown/album-groupe-dropdown.component';
import { CategoryChantDropdownComponent } from './category-chant-dropdown/category-chant-dropdown.component';
import { GroupeChantantDropdownComponent } from './groupe-chantant-dropdown/groupe-chantant-dropdown.component';
import { LangueDropdownComponent } from './langue-dropdown/langue-dropdown.component';
import { GenreMusicalMultiselectComponent } from './genre-musical-multiselect/genre-musical-multiselect.component';
import { StyleMusicalMultiselectComponent } from './style-musical-multiselect/style-musical-multiselect.component';
import { ArtistMultiselectComponent } from './artist-multiselect/artist-multiselect.component';
import { InputTextFieldComponent } from './input-text-field/input-text-field.component';
import { InputGroupTextFieldComponent } from './input-group-text-field/input-group-text-field.component';
import { PositionInputGroupComponent } from './position-input-group/position-input-group.component';
import { MediaPlayerButtonComponent } from './media-player-button/media-player-button.component';



@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    GroupeChantantDropdownComponent,
    CategoryChantDropdownComponent,
    AlbumGroupeDropdownComponent,
    LangueDropdownComponent,
    GenreMusicalMultiselectComponent,
    StyleMusicalMultiselectComponent,
    ArtistMultiselectComponent,
    InputTextFieldComponent,
    InputGroupTextFieldComponent,
    PositionInputGroupComponent,
    MediaPlayerButtonComponent,
  ],
  exports:[
    GroupeChantantDropdownComponent,
    CategoryChantDropdownComponent,
    AlbumGroupeDropdownComponent,
    LangueDropdownComponent,
    GenreMusicalMultiselectComponent,
    StyleMusicalMultiselectComponent,
    ArtistMultiselectComponent,
    InputTextFieldComponent,
    InputGroupTextFieldComponent,
    PositionInputGroupComponent,
    MediaPlayerButtonComponent,
  ]
})
export class ControlsModuleModule { }
